import type { ReactElement } from 'react'
import { Box, Container, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useAppFooterCenterTextValue } from '../contexts/AppFooterContext'
import { useIsPhoneLayout } from '../hooks/useViewport'

export default function AppFooter(): ReactElement {
  const centerText = useAppFooterCenterTextValue()
  const isPhone = useIsPhoneLayout()

  return (
    <Box
      component="footer"
      sx={{ borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper', color: 'text.secondary', fontSize: 12.5 }}
    >
      <Container
        maxWidth="xl"
        sx={{
          minHeight: 52,
          py: { xs: 1, sm: 0 },
          display: 'flex',
          ...(isPhone
            ? { flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: 0.5 }
            : { alignItems: 'center', flexWrap: 'wrap', columnGap: 2, rowGap: 0.5 })
        }}
      >
        <Box component="span" sx={{ fontWeight: 600 }}>Светобур · Бэкофис</Box>
        <Box component="span" sx={{ flex: isPhone ? 'none' : 1, minWidth: 0, fontVariantNumeric: 'tabular-nums' }}>
          {centerText}
        </Box>
        <Link component={RouterLink} to="/feedback" underline="hover" color="inherit" sx={{ fontSize: 'inherit' }}>
          Обратная связь
        </Link>
      </Container>
    </Box>
  )
}
